import { Link } from 'react-router-dom';
import { useAuth } from '@screentone/addon-auth-wrapper';
import { Button, Wrapper } from '@screentone/core';

import { NoSearchResults } from 'components/no-search-results/NoSearchResults';
import { Layout } from 'data/generated/graphql';
import styles from './LayoutsList.module.scss';
import type { LayoutList } from '../../Layouts';

interface LayoutsListProps {
  layouts: LayoutList[];
}

export const LayoutsList = ({ layouts }: LayoutsListProps) => {
  const { currentProperty } = useAuth();

  if (layouts.length === 0) {
    return (
      <NoSearchResults title="Layouts" bodyText="No layouts found for this publication. Try a different filter." />
    );
  }

  return (
    <Wrapper data-testid="layouts-list">
      {layouts.map((layout) => {
        const body = layout.body as Layout;
        return (
          <Button
            key={layout.artifactId}
            componentEl={Link}
            to={`/${currentProperty ?? ''}/site-config/layouts/${layout.artifactId}`}
            className={styles.layoutItem}
            secondary
            fullWidth
            margin={{
              vertical: 'sm'
            }}
          >
            {body.name}
          </Button>
        );
      })}
    </Wrapper>
  );
};
